<template>
  <b-modal
    id="debtorItemModal"
    ref="debtorItemModal"
    size="lg"
    :title="modalTitle"
    no-close-on-backdrop
    @close="close"
  >
    <b-form id="debtorForm" @submit.prevent="saveDebtor">
      <b-form-group label-cols="3" label="รหัสลูกค้า:" label-align="right">
        <b-form-input
          class="required"
          v-model="debtorItem.erpCustomerNo"
          :class="{ 'is-invalid': $v.debtorItem.erpCustomerNo.$error }"
          :disabled="!isNewDebtor"
          maxlength="50"
          placeholder="กรอกรหัสลูกค้า"
        ></b-form-input>
      </b-form-group>

      <b-form-group label-cols="3" label="ชื่อลูกค้า:" label-align="right">
        <b-form-input
          class="required"
          v-model="debtorItem.customerName"
          :class="{ 'is-invalid': $v.debtorItem.customerName.$error }"
          maxlength="100"
          placeholder="กรอกชื่อลูกค้า"
        ></b-form-input>
      </b-form-group>

      <b-form-group label-cols="3" label="ที่อยู่:" label-align="right">
        <b-form-textarea
          class="required"
          v-model="debtorItem.address"
          :class="{ 'is-invalid': $v.debtorItem.address.$error }"
          maxlength="255"
          rows="3"
          placeholder="กรอกที่อยู่"
        ></b-form-textarea>
      </b-form-group>

      <b-form-group label-cols="3" label="ที่อยู่ 2:" label-align="right">
        <b-form-input
          v-model="debtorItem.address2"
          maxlength="255"
          placeholder="กรอกที่อยู่เพิ่มเติม (ถ้ามี)"
        ></b-form-input>
      </b-form-group>

      <b-form-group label-cols="3" label="เมือง:" label-align="right">
        <b-form-input
          v-model="debtorItem.city"
          maxlength="100"
          placeholder="กรอกเมือง"
        ></b-form-input>
      </b-form-group>

      <b-form-group label-cols="3" label="จังหวัด:" label-align="right">
        <b-form-input
          v-model="debtorItem.county"
          maxlength="100"
          placeholder="กรอกจังหวัด"
        ></b-form-input>
      </b-form-group>

      <b-form-group label-cols="3" label="รหัสไปรษณีย์:" label-align="right">
        <b-form-input
          v-model="debtorItem.postCode"
          maxlength="10"
          placeholder="กรอกรหัสไปรษณีย์"
        ></b-form-input>
      </b-form-group>

      <b-form-group label-cols="3" label="เบอร์โทร:" label-align="right">
        <b-form-input
          v-model="debtorItem.phoneNo"
          maxlength="20"
          placeholder="กรอกเบอร์โทร"
        ></b-form-input>
      </b-form-group>

      <b-form-group label-cols="3" label="ผู้ติดต่อ:" label-align="right">
        <b-form-input
          v-model="debtorItem.contact"
          maxlength="100"
          placeholder="กรอกชื่อผู้ติดต่อ"
        ></b-form-input>
      </b-form-group>

      <b-form-group label-cols="3" label="เบอร์แฟกซ์:" label-align="right">
        <b-form-input
          v-model="debtorItem.faxNo"
          maxlength="30"
          placeholder="กรอกเบอร์แฟกซ์"
        ></b-form-input>
      </b-form-group>

      <b-form-group label-cols="3" label="อีเมล:" label-align="right">
        <b-form-input
          v-model="debtorItem.email"
          maxlength="80"
          placeholder="กรอกอีเมล"
        ></b-form-input>
      </b-form-group>

      <b-form-group label-cols="3" label="เว็บไซต์:" label-align="right">
        <b-form-input
          v-model="debtorItem.webSite"
          maxlength="255"
          placeholder="กรอกเว็บไซต์"
        ></b-form-input>
      </b-form-group>

      <b-form-group label-cols="3" label="เลขผู้เสียภาษี:" label-align="right">
        <b-form-input
          class="required"
          v-model="debtorItem.vatRegistrationNo"
          :class="{ 'is-invalid': $v.debtorItem.vatRegistrationNo.$error }"
          maxlength="20"
          placeholder="กรอกเลขผู้เสียภาษี"
        ></b-form-input>
      </b-form-group>

      <b-form-group label-cols="3" label="Customer Template:" label-align="right">
        <b-form-input
          class="required"
          v-model="debtorItem.customerTemplate"
          :class="{ 'is-invalid': $v.debtorItem.customerTemplate.$error }"
          maxlength="100"
          placeholder="กรอก Customer Template"
        ></b-form-input>
      </b-form-group>
    </b-form>

    <template v-slot:modal-footer>
      <b-button v-if="!isNewDebtor" variant="danger" @click="deleteDebtor(debtorItem)">
        ลบรายการ
      </b-button>
      <b-button type="submit" form="debtorForm" variant="primary">
        {{ isNewDebtor ? "สร้างรายการ" : "แก้ไขรายการ" }}
      </b-button>
    </template>
    <Dialog ref="Dialog"></Dialog>
    <Loading v-if="isLoading"></Loading>
  </b-modal>
</template>

<script>
import Dialog from "@/components/modal/Dialog";
import Loading from "@/components/Loading";
import { required } from "vuelidate/lib/validators";
export default {
  name: "DebtorItemModal",
  components: {
    Dialog,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      modalTitle: "รายการ Contract",
      isNewDebtor: true,
      debtorItem: {
        id: null,
        erpCustomerNo: "",
        customerName: "",
        address: "",
        address2: "",
        city: "",
        county: "",
        postCode: "",
        phoneNo: "",
        contact: "",
        faxNo: "",
        email: "",
        webSite: "",
        vatRegistrationNo: "",
        customerTemplate: "",
      },
    };
  },
  validations: {
    debtorItem: {
      erpCustomerNo: { required },
      customerName: { required },
      address: { required },
      vatRegistrationNo: { required },
      customerTemplate: { required },
    },
  },
  methods: {
    show(data) {
      if (data) {
        this.isNewDebtor = false;
        this.debtorItem = Object.assign({}, data);
      } else {
        this.isNewDebtor = true;
        this.setDefaultValue();
      }
      this.$bvModal.show("debtorItemModal");
    },
    close() {
      this.$v.$reset();
      this.setDefaultValue();
      this.isNewDebtor = true;
      this.$bvModal.hide("debtorItemModal");
    },
    setDefaultValue() {
      this.debtorItem = Object.assign(
        {},
        {
          id: null,
          erpCustomerNo: "",
          customerName: "",
          address: "",
          address2: "",
          city: "",
          county: "",
          postCode: "",
          phoneNo: "",
          contact: "",
          faxNo: "",
          email: "",
          webSite: "",
          vatRegistrationNo: "",
          customerTemplate: "",
        }
      );
    },
    saveDebtor() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.isLoading = true;

      const debtorData = {
        erpCustomerNo: this.debtorItem.erpCustomerNo,
        customerName: this.debtorItem.customerName,
        address: this.debtorItem.address,
        address2: this.debtorItem.address2 || null,
        city: this.debtorItem.city || null,
        county: this.debtorItem.county || null,
        postCode: this.debtorItem.postCode || null,
        phoneNo: this.debtorItem.phoneNo || null,
        contact: this.debtorItem.contact || null,
        faxNo: this.debtorItem.faxNo || null,
        email: this.debtorItem.email || null,
        webSite: this.debtorItem.webSite || null,
        vatRegistrationNo: this.debtorItem.vatRegistrationNo,
        customerTemplate: this.debtorItem.customerTemplate,
      };

      if (this.isNewDebtor) {
        this.$store
          .dispatch("moduleDebtor/createDebtor", {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            debtorData,
          })
          .then(res => {
            if (res.status == 201) {
              this.$emit("saved");
              this.close();
              this.$parent.showDialogToast(
                "success",
                "เพิ่มรายการ Contract สำเร็จ"
              );
            }
            this.close();
          })
          .catch(err => {
            const errorMessage = err.response?.data?.errorMessage;
            const errorMsg =
              typeof errorMessage === "string"
                ? errorMessage
                : "เพิ่มรายการ Contract ไม่สำเร็จ กรุณาลองใหม่";
            this.$parent.showDialogToast("danger", errorMsg);
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$store
          .dispatch("moduleDebtor/updateDebtor", {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            debtorData,
            debtorId: this.debtorItem.id,
          })
          .then(res => {
            if (res.status == 200) {
              this.$emit("saved");
              this.close();
              this.$parent.showDialogToast(
                "success",
                "แก้ไขรายการ Contract สำเร็จ"
              );
            }
            this.close();
          })
          .catch(err => {
            const errorMessage = err.response?.data?.errorMessage;
            const errorMsg =
              typeof errorMessage === "string"
                ? errorMessage
                : "แก้ไขรายการ Contract ไม่สำเร็จ กรุณาลองใหม่";
            this.$parent.showDialogToast("danger", errorMsg);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    deleteDebtor(eventData) {
      this.$refs.Dialog.showAlertConfirm(
        "ลบ Contract นี้ ?",
        "คุณต้องการลบ Contract นี้ใช่หรือไม่"
      ).then(result => {
        if (!result.value) return;

        this.$store
          .dispatch("moduleDebtor/deleteDebtor", {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            debtorId: this.debtorItem.id,
          })
          .then(res => {
            if (res.status == 200) {
              this.$emit("saved");
              this.close();
              this.$parent.showDialogToast(
                "success",
                "ลบรายการ Contract สำเร็จ"
              );
            }
            this.close();
          })
          .catch(err => {
            const errorMessage = err.response?.data?.errorMessage;
            const errorMsg =
              typeof errorMessage === "string"
                ? errorMessage
                : "ลบรายการ Contract ไม่สำเร็จ กรุณาลองใหม่";
            this.$parent.showDialogToast("danger", errorMsg);
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
  },
};
</script>
